import { useState } from 'react';
import { Spin, Empty } from 'antd';
import DocumentFilterBarComponent from '../components/DocumentFilterBarComponent';
import DocumentTable from '../components/DocumentTable';
import DocumentService from "../services/Document/DocumentService";
import Title from 'antd/es/typography/Title';
import { useLocation, useNavigate } from 'react-router-dom';

const DocumentListPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [filters, setFilters] = useState(location.state?.filters ? location.state?.filters : {});
    const [pagedResult, setPagedResult] = useState({ data: [], total: 0 });
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(50);

    const fetchDocuments = (newFilters = filters, page = currentPage, size = rowsPerPage) => {
        setLoading(true);
        const payload = { ...newFilters, pageNumber: page, pageSize: size };

        DocumentService.searchDocuments(payload)
            .then((res) => {
                const result = res.data; // Extract the actual payload
                setPagedResult({
                    data: Array.isArray(result.data) ? result.data : [],
                    total: result.total ?? 0,
                });
                setFilters(newFilters);
            })

            .catch((err) => {
                console.error('Error fetching documents:', err);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const handleSearch = (searchFilters) => {
        fetchDocuments(searchFilters, 1, rowsPerPage); // reset to page 1 on new search
    };

    const handleReset = (clearedFilters = {}) => {
        setFilters(clearedFilters);       // Reset filters to empty
        setPagedResult({
            data: [],
            toal: 0
        });
    };

    const handlePageChange = (page, size) => {
        setCurrentPage(page);
        setRowsPerPage(size);
        fetchDocuments(filters, page, size);
    };

    const handleViewDetails = (record) => {
        switch (record.entityType) {
            case 'PurchaseOrder':
                navigate("/purchase-order/details", {
                    state: {
                        pathname: location.pathname,
                        purchaseOrderId: record.entityID,
                        purchaseOrderNumber: record.poNumber,
                    },
                });
                break;
            case 'Container':
                navigate("/shipment-gateway/shipment-details", {
                    state: {
                        pathname: location.pathname,
                        containerID: record?.containerID || null,
                        filters: filters,
                    },
                });
                break;
            default:
                break;
        }
    };

    return (
        <div className="px-2 relative  w-full h-full">
            <div className="flex justify-between items-center w-full my-2  px-2">
                <div className="flex justify-start items-center font-inter">
                    <span
                        className="!font-medium text-[30px] !text-[#015373] !m-0 pl-4 mt-10"
                    >
                        Document Search
                    </span>
                </div>
            </div>
            <DocumentFilterBarComponent onSearch={handleSearch} onReset={handleReset} initialFilters={filters} />
            <div >
                {loading ? (
                    <Spin tip="Loading documents..." className='w-full h-full' />
                ) : !Array.isArray(pagedResult.data) || pagedResult.data.length === 0 ? (
                    <Empty description="No documents found. Try adjusting your filters." />
                ) : (
                    <DocumentTable
                        items={pagedResult.data}
                        totalCount={pagedResult.total}
                        pageNumber={currentPage}
                        pageSize={rowsPerPage}
                        onPageChange={handlePageChange}
                        handleViewDetails={handleViewDetails}
                    />
                )}
            </div>
        </div>
    );
};

export default DocumentListPage;


